import { Calendar } from "primereact/calendar";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { useRef } from "react";
import { mmddyyyyToDate, dateToMMDDYYYY } from "../../date-utils";
import { InUseDecoration } from "../in-use-decoration/InUseDecoration";
import styles from "./Filters.module.css";

type EffectiveDateFilterProps = {
  effectiveDateStart: string;
  effectiveDateEnd: string;
  onChangeStart: (value: string) => void;
  onChangeEnd: (value: string) => void;
  onClearBoth: () => void;
};

export const EffectiveDateFilter: React.FC<EffectiveDateFilterProps> = ({
  effectiveDateStart,
  effectiveDateEnd,
  onChangeStart,
  onChangeEnd,
  onClearBoth,
}) => {
  const op = useRef<OverlayPanel>(null);

  const startDate = effectiveDateStart
    ? mmddyyyyToDate(effectiveDateStart)
    : undefined;
  const endDate = effectiveDateEnd
    ? mmddyyyyToDate(effectiveDateEnd)
    : undefined;

  const activeCount = (effectiveDateStart ? 1 : 0) + (effectiveDateEnd ? 1 : 0);

  return (
    <>
      <div
        className={styles.decorationWrapper}
        style={{ cursor: "pointer" }}
        onClick={(e) => op.current?.toggle(e)}
      >
        <span className="pi pi-filter"></span>
        {activeCount > 0 ? <InUseDecoration count={activeCount} /> : null}
      </div>
      <OverlayPanel
        ref={op}
        onClick={(e) => e.stopPropagation()}
        dismissable
        style={{ width: "280px" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div>
            <label
              style={{
                fontWeight: "bold",
                fontSize: "13px",
                display: "block",
                marginBottom: "4px",
              }}
            >
              From
            </label>
            <Calendar
              value={startDate ?? null}
              onChange={(e) => {
                if (e.value) {
                  onChangeStart(dateToMMDDYYYY(e.value as Date));
                } else {
                  onChangeStart("");
                }
              }}
              readOnlyInput
              showButtonBar
              style={{ width: "100%" }}
            />
          </div>
          <div>
            <label
              style={{
                fontWeight: "bold",
                fontSize: "13px",
                display: "block",
                marginBottom: "4px",
              }}
            >
              To
            </label>
            <Calendar
              value={endDate ?? null}
              onChange={(e) => {
                if (e.value) {
                  onChangeEnd(dateToMMDDYYYY(e.value as Date));
                } else {
                  onChangeEnd("");
                }
              }}
              readOnlyInput
              showButtonBar
              style={{ width: "100%" }}
            />
          </div>
          {activeCount > 0 && (
            <Button
              label="Clear dates"
              severity="secondary"
              text
              size="small"
              onClick={() => onClearBoth()}
            />
          )}
        </div>
      </OverlayPanel>
    </>
  );
};
